import Vue from 'vue'
import { ignoreTraceErrorToHubble } from '@/util/tools'
// import { noop } from 'lodash'
const windowLibTrack = window.lib && window.lib.track

class Track {
  init() {
    try {
      windowLibTrack.init.apply(windowLibTrack, arguments)
      console.log(`%c lib track 初始化完成`, 'background: #1475B2;color: #fff;padding: 5px;')
    } catch (e) {
      console.log(e)
    }
  }
  tap() {
    try {
      windowLibTrack.tap.apply(windowLibTrack, arguments)
    } catch (e) {
      console.log(e)
    }
  }
  view() {
    try {
      windowLibTrack.view.apply(windowLibTrack, arguments)
    } catch (e) {
      console.log(e)
    }
  }
  trace() {
    try {
      windowLibTrack.trace.apply(windowLibTrack, arguments)
    } catch (e) {
      console.log(e)
    }
  }
  /**
   * 大前端日志 error
   * 流程发生了错误，但可能不影响 App 继续运行，会根据阈值来告警
   * @param feature 具体的特征或属性，作为hubble行为日志的标题展示
   * @param params
   * message: 用于记录详细信息，比如堆栈、业务数据等详细信息，用于排查问题
   * type: 可选参数，业务自定义类型，不传默认 Fatal / Error / Warn / Info, 业务自定义type需由业务稳定性负责人自行配置告警
   * stack: 可选参数
   * @param type
   */
  error(feature, params, type) {
    try {
      params = params || {}
      if (type) {
        windowLibTrack.error(feature, { stack: params, type })
      } else {
        // 过滤无意义的业务报错场景
        ignoreTraceErrorToHubble(params?.stack, () => {
          windowLibTrack.error(feature, params)
          console.log(new Date().toString() + '[track.error]feature：', feature)
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  warn(feature, params) {
    try {
      params = params || {}
      // 过滤无意义的业务报错场景
      ignoreTraceErrorToHubble(params?.stack, () => {
        windowLibTrack.warn(feature, params)
        console.log(new Date().toString() + '[track.warn]feature：', feature)
      })
    } catch (e) {
      console.log(e)
    }
  }
  pageviewStayDuration() {
    try {
      windowLibTrack.pageviewStayDuration.apply(windowLibTrack, arguments)
    } catch (e) {
      console.log(e)
    }
  }
  pageview() {
    try {
      windowLibTrack.pageview.apply(windowLibTrack, arguments)
    } catch (e) {
      console.log(e)
    }
  }
  metric() {
    try {
      windowLibTrack.metric.apply(windowLibTrack, arguments)
    } catch (e) {
      console.error(e)
    }
  }

  /**
   * 上报自定义监控日志到Hubble（仅h5支持）
   * params: { category, metric, attrs, ext }，其中category默认是custom
   * 参数说明： https://yapi.amh-group.com/#/project/1649/interface/api/109606
   */
  monitor() {
    try {
      // lib.track.monitor({ category = 'custom', metric, attrs, ext })
      windowLibTrack._monitor.apply(windowLibTrack, arguments)
    } catch (e) {
      console.error(e)
    }
  }

  pageNameHandler() {
    try {
      return windowLibTrack?.trackModel?.pageNameHandler?.apply?.(windowLibTrack, arguments)
    } catch (e) {
      return '未知页面'
    }
  }
}
const libTrack = new Track()
// const libTrack = new Proxy( windowLibTrack || {}, {
//   get(target, prop, receiver) {
//     console.log(11, prop);
//     if(typeof target[prop] === 'function') {
//       return function() {
//         try {
//           target[prop].apply(target, arguments)
//         } catch (e){
//           console.log(e)
//         }
//       }
//     } else {
//       if(target.hasOwnProperty(prop)) return target[prop]
//       return noop
//     }
//   }
// })

Vue.prototype.$libTrack = libTrack

try {
  Vue.config.errorHandler = (err, vm, info) => {
    console.warn('【系统报错】：', err)
    console.warn('【系统报错】：', vm)
    console.warn('【系统报错】：', info)
    if (err instanceof Error) {
      // window.TruckSentry && window.TruckSentry.captureException(err)
    } else {
      let errorMsg = typeof err === 'string' ? err : err?.message
      if (err?.response?.request) {
        errorMsg = `接口业务报错：${errorMsg}`
      }
      if (!errorMsg) {
        errorMsg = 'error'
        console.warn(err) // 排查使用
      }
      const Err = new Error(errorMsg)
      Err.response = err.response
      // window.TruckSentry?.withScope?.(scope => {
      //   scope.setExtra('Error.info', info)
      //   scope.setExtra('vm.$route.path', vm?.$route?.path)
      //   scope.setExtra('vm.$options.name', vm?.$options?.name)
      //   window.TruckSentry && window.TruckSentry.captureException(Err)
      // })
    }
  }
} catch (e) {
  console.warn('【系统报错】：', e?.message)
}

export default libTrack
